export { ConfirmRemoveDocument } from './ConfirmRemoveDocument';
